import { Component } from '@angular/core';

@Component({
  selector: 'piqet-angular-edit-icon-component',
  template: `
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_9114_31)">
        <circle cx="40" cy="40" r="20" fill="#9747FF" />
      </g>
      <g clip-path="url(#clip0_9114_31)">
        <path
          d="M35.5521 48.7352L49.2401 35.0552L44.8001 30.6152L31.1201 44.3032V48.7432L35.5521 48.7352Z"
          stroke="white"
          stroke-width="1.4"
          stroke-miterlimit="10"
        />
        <path
          d="M47.5599 36.7359L43.1199 32.2959L41.1279 34.2879"
          stroke="white"
          stroke-width="1.4"
          stroke-miterlimit="10"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_9114_31"
          x="0"
          y="0"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9114_31" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_9114_31"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_9114_31">
          <rect
            width="19.856"
            height="19.864"
            fill="white"
            transform="translate(30.4004 29.5996)"
          />
        </clipPath>
      </defs>
    </svg>
  `,
  styles: [
    `
      svg g circle:hover {
        fill: #7135bf;
      }
    `,
  ],
})
export class SharedSvgComponent {}
